<ng-container *ngIf="!isIe;else ietemplate">
    <div #main class="cnt-row-centered btn-main btn-main-el" style="justify-content: center" (mouseenter)="mouseIn()" (mouseleave)="mouseOut()">
        <div #btncontent class="cnt-row-centered">
            <ng-container *ngIf="leftImgCls">
                <div #leftImg style="float: left; display: inline-block; position: relative;" class="left">
                    <div [attr.data-testid]="testid + '-img'" class="imgdiv {{leftImgCls}}"></div>
                    <div class="imgdiv {{leftImgHoverCls}}" style="opacity:0"></div>
                </div>
            </ng-container>
            <div #textEl [attr.data-testid]="testid + '-text'" class="{{textCls}} txtCls btn-text-el nonselectable" style="float: left; display: inline-block; padding-bottom: 1px" [style.fontSize]="fontSize" 
                 [style.fontWeight]="fontWeight" [style.fontFamily]="fontFamily">{{text}}</div>
            <ng-container *ngIf="rightImgCls">
                <div #rightImg style="float: right; display: inline-block; position: relative;" class="right">
                    <div [attr.data-testid]="testid + '-img'" class="imgdiv {{rightImgCls}}"></div>
                    <div class="imgdiv {{rightImgHoverCls}}" style="opacity:0"></div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>

<ng-template #ietemplate>
    <div #main class="cnt-row-centered btn-main btn-main-el" style="justify-content: center" (mouseenter)="mouseIn()" (mouseleave)="mouseOut()">
        <div #btncontent class="cnt-row-centered btncontent" style="display: table-row;">
            <ng-container *ngIf="leftImgCls">

                <div style="display: table-cell; vertical-align: middle;">

                    <div #leftImg style="position: relative;" class="left">
                        <div [attr.data-testid]="testid + '-img'" class="imgdiv {{leftImgCls}}"></div>
                        <div class="imgdiv {{leftImgHoverCls}}" style="opacity:0"></div>
                    </div>

                </div>

            </ng-container>
            <div #textEl [attr.data-testid]="testid + '-text'" class="{{textCls}} txtCls btn-text-el nonselectable" style="display: table-cell;vertical-align: middle;" 
                 [style.fontSize]="fontSize" [style.fontWeight]="fontWeight" [style.fontFamily]="fontFamily">{{text}}</div>
            <ng-container *ngIf="rightImgCls">
                <div style="display: table-cell; vertical-align: middle;">
                    <div #rightImg style="position: relative;" class="right">
                        <div [attr.data-testid]="testid + '-img'" class="imgdiv {{rightImgCls}}"></div>
                        <div class="imgdiv {{rightImgHoverCls}}" style="opacity:0"></div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>